import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query ProductInfo($locale: String!, $preview: Boolean) {
    productPageInfoCollection(limit: 1, locale: $locale) {
      items {
        ...productPageInfo
      }
    }
  }
`);
